import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { toggleCheckbox } from '@features/filter/static/filterUtil';

import { storeItemInGlobalFilter } from '@store/actions/FilterAction';
import { fetchMarketList } from '@store/actions/MarketAction';

const Market = () => {
	const marketList = useSelector((store) => store.marketStore);
	const dispatch = useDispatch();
	const filterData = useSelector((store) => store.filterFieldStore);

	useEffect(() => {
		if (marketList?.length === 0) {
			dispatch(fetchMarketList());
		}
	}, []);

	const handleCheckbox = (e, title) => {
		let { value, checked, name } = e.target;
		let data = {
			name: 'marketId',
			key: value,
			value: title,
			identifier: name,
			checked: checked
		};
		dispatch(storeItemInGlobalFilter(data));
	};

	const renderMarketList = () => {
		return marketList.map((item, index) => {
			return (
				<div className="form-group" key={`filter_market_${index}`}>
					<input
						type="checkbox"
						id={`market_${index}`}
						name={`market_${index}`}
						value={item.id}
						onChange={(e) => handleCheckbox(e, item.name)}
						checked={toggleCheckbox(filterData, 'marketId', `market_${index}`)}
					/>
					<label htmlFor={`market_${index}`}>
						<span>{item.name}</span>
					</label>
				</div>
			);
		});
	};

	return (
		<div className="card">
			<div className="card-header" id="headingMarket">
				<h5 className="mb-0">
					<button
						className="btn btn-link collapsed"
						data-toggle="collapse"
						data-target="#collapseMarket"
						aria-expanded="false"
						aria-controls="collapseMarket"
					>
						Market
					</button>
				</h5>
			</div>

			<div
				id="collapseMarket"
				className="collapse"
				aria-labelledby="headingMarket"
				data-parent="#accordion"
			>
				<div className="card-body">
					<div className="custom-chekbox">{renderMarketList()}</div>
				</div>
			</div>
		</div>
	);
};

export default Market;
